import React, { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { login } from "../../store/actions/authActions";
import Alert from "../../components/alert/Alert";

import "./Login.css";
import { Redirect } from "react-router";

function Login({ login, alerts, auth }) {

  const defaultState = {
    email: "",
    password: ""
  }

  const [fields, setFields] = useState(defaultState);

  const onSubmit = (event) => {
    event.preventDefault();
    login(fields.email, fields.password);    
  };

  const onChange = (event) => {
    const fieldName = event.target.name;
    const value = event.target.value;
    setFields((prev) => ({ ...prev, [fieldName]: value }));
  };

  if (auth.success && auth.token) {
    return (<Redirect to='/dashboard'/>);
  }

  console.log(alerts)

  return (
    <div className="login">
     <Alert alerts={alerts} />
      <h1 className="title">Sign In</h1>
      <br />
      <Form className="login-form">
        <Form.Group className="form-group mb-3">
          <Form.Label>Email</Form.Label>
          <Form.Control onChange={onChange} name="email" value={fields.email} type="email" placeholder="Enter email" required />
        </Form.Group>

        <Form.Group className="form-group mb-3">
          <Form.Label>Password</Form.Label>
          <Form.Control onChange={onChange} name="password" value={fields.password} type="password" placeholder="Enter password" required />
        </Form.Group>

        <Button onClick={onSubmit} className="login-submit-btn" type="submit">
          Submit
        </Button>
      </Form>
    </div>
  );
}

const mapStateToProps = (state) => ({
  alerts: state.alert,
  auth: state.auth
});

export default connect(mapStateToProps, { login })(Login);
